import React from 'react';
import {labels} from '../../../../../../util/utils';
import Utility from '../../../../../../util/utilityfunctions';
import {dashboardChartColors} from '../../../../../../util/uiconstants';

export default (
	formatId,
	total,
	numberFormat,
	taskNotSent,
	taskNotSentOverdue,
	taskNotSentPercent,
	taskReturned,
	taskReturnedOverdue,
	taskReturnedPercent,
	taskPartialSend,
	taskPartialSendPercent,
	taskCompleteSend,
	taskCompleteSendPercent,
	taskUnlinked
) => {
	const getTooltipText = (label, value, percent) => {
		return `${label} | ${Utility.getFormattedNumber(numberFormat, value)} (${percent}%)`;
	};

	const data = {
		chartsData: [
			{
				barStyling: {
					chartWidth: 240,
					styleName: 'groupReportItem',
					chartWrapper: 'groupAuditchart',
					tooltipBorderColor: 'grey',
					tooltipBackground: 'white',
					styleBarcountClass: 'group-audit-count-wrap'
				},
				headerText: labels.dueToPrimaryTeam,
				numberFormat: formatId,
				barMaxValue: total,
				showBarTitleTip: true,
				barItems: [
					{
						count: taskNotSent,
						label: labels.groupAuditNotSent,
						statusClass: 'notSent motif-body2-default-regular',
						color: dashboardChartColors.teal[0],
						warningMessage: (
							<span className="motif-body3-default-light">
								{taskNotSentOverdue > 0
									? `${Utility.getFormattedNumber(numberFormat, taskNotSentOverdue)} ${labels.overdue}`
									: ''}
							</span>
						),
						toolTip: getTooltipText(labels.groupAuditNotSent, taskNotSent, taskNotSentPercent)
					},
					{
						count: taskReturned,
						label: labels.returned,
						statusClass: 'returned motif-body2-default-regular',
						color: dashboardChartColors.teal[1],
						warningMessage: (
							<span className="motif-body3-default-light">
								{taskReturnedOverdue > 0
									? `${Utility.getFormattedNumber(numberFormat, taskReturnedOverdue)} ${labels.overdue}`
									: ''}
							</span>
						),
						toolTip: getTooltipText(labels.returned, taskReturned, taskReturnedPercent)
					}
				]
			},
			{
				barStyling: {
					chartWidth: 240,
					styleName: 'groupReportItem',
					chartWrapper: 'groupAuditchart',
					tooltipBorderColor: 'grey',
					tooltipBackground: 'white',
					styleBarcountClass: 'group-audit-count-wrap'
				},
				headerText: labels.sentToPrimaryTeam,
				numberFormat: formatId,
				barMaxValue: total,
				showBarTitleTip: true,
				barItems: [
					{
						count: taskPartialSend,
						label: labels.evidencePending,
						statusClass: 'docPending motif-body2-default-regular',
						color: dashboardChartColors.teal[2],
						toolTip: getTooltipText(labels.evidencePending, taskPartialSend, taskPartialSendPercent)
					},
					{
						count: taskCompleteSend,
						label: labels.evidenceComplete,
						statusClass: 'docComplete motif-body2-default-regular',
						color: dashboardChartColors.teal[3],
						toolTip: getTooltipText(labels.evidenceComplete, taskCompleteSend, taskCompleteSendPercent)
					}
				]
			}
		],
		taskUnlinked: taskUnlinked,
		total: total
	};
	return data;
};
